export enum UserRoles {
  DOCTOR_USER = "doctor:user",
  DOCTOR_BASIC_USER = "doctor-basic:user",
  ASSISTANT_USER = "assistant:user",
  ORTHOSNAP_USER = "orthosnap:user",
  ORTHOSNAP_TECH_USER = "orthosnap-tech:user",
}
